<template>
<!--内容管理-->
  <div id="onManagement" style="padding-bottom: 10px">
    <div class="allMenuHead">
        <!-- v-if="$childMenu.indexOf('草稿箱') >= 0"  -->
      <div :class="step === 1 ? 'active' : ''" v-if="$childMenu.indexOf('直播管理') >= 0" @click="toUrl('onLiveList', 1)" class="d_i headTab p_r">直播管理<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
let reflashTime
export default {
  name: 'onManagement',
  data () {
    return {
      step: 1,
      ContentReleaseNumber: '',
      UnReviewCount: '',
      size: 1,
      showMenu: true,
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isAdmin: window.localStorage.getItem('isAdmin')
    }
  },
  created () {
    if (window.screen.width < 1400) {
      this.size = 0.92
    }
    console.log(this.size)
    Time = setInterval(p => {
      if (window.location.href.indexOf('onLiveList') >= 0) {
        this.step = 1
      }
    }, 100)
    reflashTime = setInterval(p => {
      let data = window.sessionStorage.getItem('reflash')
      if (data === 'need') {
        window.sessionStorage.setItem('reflash', '')
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
    clearInterval(reflashTime)
  },
  methods: {
    toUrl (url, num) {
      this.step = num
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/onManagement/onManagement.vue